import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import NoMatch from './pages/404';
import Home from './home';
import PageNotFound from './pages/404';
import ProductDetail from './pages/ProductDetail';
import SignIn from "./pages/SignIn"
import Dashboard from "./pages/Dashboard"

import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import 'babel-polyfill'
import { Provider } from 'react-redux';
import store from './store/store';
import Address from './pages/Address';
import PaymentSelect from './pages/PaymentSelect';
import PaymentEnd from './pages/PaymentEnd';
import ProductByCategory from "./pages/ProductsByCategory";

class Root extends React.Component {
	render() {
		return (
			<Provider store={store}>
				<BrowserRouter history={createBrowserHistory}>
					<Switch>
						{/* <Route exact path={`${process.env.PUBLIC_URL}/`} component={App}/> */}
						<Route exact path={`${process.env.PUBLIC_URL}/`} component={() => <Home />} />
						<Route exact path={`${process.env.PUBLIC_URL}/ar`} component={() => <Home />} />
						<Route exact path={`${process.env.PUBLIC_URL}/clientwebsite2`} component={() => <Home />} />

						<Route exact path={`${process.env.PUBLIC_URL}/clientwebsite/ar`} component={() => <Home />} />
						<Route exact path={`${process.env.PUBLIC_URL}/clientwebsite2/ar`} component={() => <Home />} />

						<Route exact path={`${process.env.PUBLIC_URL}/instagram`} component={() => <Home />} />
						<Route exact path={`${process.env.PUBLIC_URL}/snap`} component={() => <Home />} />



						{/** Remove later */}
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/address`}
							component={() => <Address />}
						/>

						<Route
							path={`${process.env.PUBLIC_URL}/clientwebsite2/address`}
							component={() => <Address />}
						/>
						{/** Remove later */}
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/paymentselect`}
							component={() => <PaymentSelect />}
						/>

						<Route
							exact
							path={`${process.env.PUBLIC_URL}/productDetail/:productId`}
							component={() => <ProductDetail />}
						/>
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/clientwebsite/productDetail/:productId`}
							component={() => <ProductDetail />}
						/>
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/clientwebsite2/productDetail/:productId`}
							component={() => <ProductDetail />}
						/>
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/clientwebsite2/paymentselect`}
							component={() => <PaymentSelect />} />


						<Route
							exact
							path={`${process.env.PUBLIC_URL}/clientwebsite2/paymentend`}
							component={() => <PaymentEnd />}
						/>

						<Route
							exact
							path={`${process.env.PUBLIC_URL}/paymentend`}
							component={() => <PaymentEnd />}
						/>

						<Route
							exact
							path={`${process.env.PUBLIC_URL}/signin`}
							component={() => <SignIn />}
						/>
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/dashboard`}
							component={() => <Dashboard />}
						/>

						<Route exact path={`${process.env.PUBLIC_URL}/category/:categoryId`} component={() => <ProductByCategory />} />
						<Route
							exact
							path={`${process.env.PUBLIC_URL}/clientwebsite2/category/:categoryId`}
							component={() => <ProductByCategory />}
						/>

						{/* <Route path={`${process.env.PUBLIC_URL}/home`} component={Home}/> */}

						<Route path={`${process.env.PUBLIC_URL}/404`} component={PageNotFound} />



						<Route component={NoMatch} />
					</Switch>
				</BrowserRouter>
			</Provider>
		);
	}
}

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
	ReactDOM.hydrate(<Root />, rootElement);
} else {
	ReactDOM.render(<Root />, rootElement);
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js